export const colors = [
  '#ff0000',
  '#00ff00',
  '#0000ff',
  '#ffff00',
  '#ff00ff',
  '#00ffff',
  '#800000',
  '#008000',
  '#000080',
  '#808000',
  '#800080',
  '#008080',
  '#ff6666',
  '#66ff66',
  '#6666ff',
  '#ffff66',
  '#ff66ff',
  '#66ffff',
  '#ff9933',
  '#33ff99',
  '#9933ff',
  '#99ff33',
  '#ff33cc',
  '#33ccff',
  '#cc33ff',
  '#ccff33',
  '#ff3399',
  '#3399ff',
  '#99ff99',
  '#9999ff',
  '#ff9999',
  '#9999ff',
];

// const styles = getComputedStyle(document.documentElement);
// export const colorSS = String(styles.getPropertyValue('--ion-color-ORYX-primary700')).trim(); // Blue
// export const colorST = String(styles.getPropertyValue('--ion-color-ORYX-teal800')).trim(); // Lightblue'#D97706';
// export const colorSC = String(styles.getPropertyValue('--ion-color-ORYX-light-blue500')).trim(); // Medium blue"#FF0000";

// export const colorCS = String(styles.getPropertyValue('--ion-color-ORYX-error700')).trim(); // red
// export const colorCT = String(styles.getPropertyValue('--ion-color-ORYX-warning600')).trim(); // orange
// export const colorCC = String(styles.getPropertyValue('--ion-color-ORYX-amber400')).trim(); // green

// export const colorTS = String(styles.getPropertyValue('--ion-color-ORYX-emerald900')).trim();
// export const colorTT = String(styles.getPropertyValue('--ion-color-ORYX-success600')).trim();
// export const colorTC = String(styles.getPropertyValue('--ion-color-ORYX-emerald400')).trim();

// export const colorLeft = String(styles.getPropertyValue('--ion-color-ORYX-primary700')).trim();
// export const colorRight = String(styles.getPropertyValue('--ion-color-ORYX-success600')).trim();
// export const colorExtra = String(styles.getPropertyValue('--ion-color-ORYX-pink900')).trim();

// export const variabilityAll_Left = String(styles.getPropertyValue('--ion-color-ORYX-light-blue500')).trim();
// export const variabilitySelected_Left = String(styles.getPropertyValue('--ion-color-ORYX-teal800')).trim();
// export const variabilityMean_Left = String(styles.getPropertyValue('--ion-color-ORYX-primary700')).trim();

// export const variabilityAll_Right = String(styles.getPropertyValue('--ion-color-ORYX-secondary600')).trim();
// export const variabilitySelected_Right = String(styles.getPropertyValue('--ion-color-ORYX-success600')).trim();
// export const variabilityMean_Right = String(styles.getPropertyValue('--ion-color-ORYX-emerald900')).trim();

// export const succesColor = String(styles.getPropertyValue('--ion-color-success')).trim();
// export const warningColor = String(styles.getPropertyValue('--ion-color-warning')).trim();
// export const dangerColor = String(styles.getPropertyValue('--ion-color-danger')).trim();
// export const primaryColor = String(styles.getPropertyValue('--ion-color-primary')).trim();

const getCssVariable = (variable: string): string => {
  return String(getComputedStyle(document.documentElement).getPropertyValue(variable)).trim();
};

const themeColorKeys = [
  'colorSS',
  'colorST',
  'colorSC',
  'colorCS',
  'colorCT',
  'colorCC',
  'colorTS',
  'colorTT',
  'colorTC',
  'colorLeft',
  'colorRight',
  'colorExtra',
  'variabilityAll_Left',
  'variabilitySelected_Left',
  'variabilityMean_Left',
  'variabilityAll_Right',
  'variabilitySelected_Right',
  'variabilityMean_Right',
  'succesColor',
  'warningColor',
  'dangerColor',
  'primaryColor',
  'sensorPlacementSelected',
  'sensorPlacementSelectedBorder',
  'sensorPlacementError',
  'sensorPlacementErrorBorder',
  'sensorPlacementNotCalibrated',
  'sensorPlacementNotCalibratedBorder',
  'sensorPlacementOutline',
] as const;

type ThemeColors = Record<(typeof themeColorKeys)[number], string>;

export const themeColors: ThemeColors = {} as ThemeColors;

export const loadThemeColors = () => {
  themeColors.colorSS = getCssVariable('--ion-color-ORYX-primary700');
  themeColors.colorST = getCssVariable('--ion-color-ORYX-teal800');
  themeColors.colorSC = getCssVariable('--ion-color-ORYX-light-blue500');
  themeColors.colorCS = getCssVariable('--ion-color-ORYX-error700');
  themeColors.colorCT = getCssVariable('--ion-color-ORYX-warning600');
  themeColors.colorCC = getCssVariable('--ion-color-ORYX-amber400');
  themeColors.colorTS = getCssVariable('--ion-color-ORYX-emerald900');
  themeColors.colorTT = getCssVariable('--ion-color-ORYX-success600');
  themeColors.colorTC = getCssVariable('--ion-color-ORYX-emerald400');
  themeColors.colorLeft = getCssVariable('--ion-color-ORYX-primary700');
  themeColors.colorRight = getCssVariable('--ion-color-ORYX-success600');
  themeColors.colorExtra = getCssVariable('--ion-color-ORYX-pink900');
  themeColors.variabilityAll_Left = getCssVariable('--ion-color-ORYX-light-blue500');
  themeColors.variabilitySelected_Left = getCssVariable('--ion-color-ORYX-teal800');
  themeColors.variabilityMean_Left = getCssVariable('--ion-color-ORYX-primary700');
  themeColors.variabilityAll_Right = getCssVariable('--ion-color-ORYX-secondary600');
  themeColors.variabilitySelected_Right = getCssVariable('--ion-color-ORYX-success600');
  themeColors.variabilityMean_Right = getCssVariable('--ion-color-ORYX-emerald900');
  themeColors.succesColor = getCssVariable('--ion-color-success');
  themeColors.warningColor = getCssVariable('--ion-color-warning');
  themeColors.dangerColor = getCssVariable('--ion-color-danger');
  themeColors.primaryColor = getCssVariable('--ion-color-primary');
  themeColors.sensorPlacementSelected = getCssVariable('--ion-color-light-blue500');
  themeColors.sensorPlacementSelectedBorder = getCssVariable('--ion-color-light-blue400');
  themeColors.sensorPlacementError = getCssVariable('--ion-color-error500');
  themeColors.sensorPlacementErrorBorder = getCssVariable('--ion-color-error500');
  themeColors.sensorPlacementNotCalibrated = getCssVariable('--ion-color-grey400');
  themeColors.sensorPlacementNotCalibratedBorder = getCssVariable('--ion-color-grey400');
  themeColors.sensorPlacementOutline = '#CBC9C3';
};

// Function to get the colors safely
export const getThemeColor = (colorName: string): string => {
  return themeColors[colorName as keyof ThemeColors] ?? 'transparent';
};
